/*
 * 몰 데이터 훅 — 🔴 **두 스킨이 같은 훅을 씁니다** (`docs/base/11` §5-2).
 *
 * 데이터 로직(무엇을 언제 부르고, 무엇을 막고, 성공하면 어디로 가는가)은 여기 있고
 * 화면(`_skins/<스킨>/screens/*`)은 그 결과를 그리기만 합니다. 스킨을 새로 만들 때 이
 * 규칙(두 번 결제 방지 · `replace` 이동 · 발급 지연 처리 · 핀 잠금)을 다시 짜지 않게 하려는
 * 것입니다. 각 파일 머리에 사용 예가 있습니다.
 *
 * 🔑 조회 훅은 전부 `useAsync` 모양(`{ data, loading, error, reload }`)이고, 동작 훅은
 *    `{ <동작>, busy, error, fields }` 모양입니다.
 */
export * from "./auth";
export * from "./coupons";
export * from "./legal";
export * from "./me";
export * from "./orders";
export * from "./products";
export * from "./seller";
